import { render } from "./ThreeDSceneEditorCmp.vue?vue&type=template&id=fec31ea4"
import script from "./ThreeDSceneEditorCmp.vue?vue&type=script&lang=js"
export * from "./ThreeDSceneEditorCmp.vue?vue&type=script&lang=js"

import "./ThreeDSceneEditorCmp.vue?vue&type=style&index=0&id=fec31ea4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__